export default __webpack_public_path__ + "static/media/svgLogo.5e71b005.png";